<template>
  <div class="reportsettingpage">
    <h1>{{ $t('SidebarMenu.Menu91') }}</h1>

    <div class="viewmodelsetting-page">
      <el-row :gutter="30">
        <el-col :span="12">
          <div class="viewmodelsetting-panel">
            <img src="@/assets/img/sku-img.png" />
            <h2>SKU</h2>
            <p>{{ $t('new.t20') }}</p>
          </div>
          <el-table size="mini" :data="skulist" tooltip-effect="dark">
            <el-table-column prop='name'></el-table-column>
            <el-table-column width="60">
              <template slot-scope="scope">
                <el-button type="arrow-btn-right" @click="setViewType(scope.row.subid, 2, scope.row.index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <div class="viewmodelsetting-panel">
            <img src="@/assets/img/spu-img.png" />
            <h2>SPU</h2>
            <p>{{ $t('new.t21') }}</p>
          </div>
          <el-table size="mini" :data="spulist" tooltip-effect="dark">
            <el-table-column width="60">
              <template slot-scope="scope">
                <el-button type="arrow-btn-left" @click="setViewType(scope.row.subid, 1, scope.row.index)"></el-button>
              </template>
            </el-table-column>
            <el-table-column prop='name'></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      brands: JSON.parse(localStorage.getItem("price")).val,
      skulist: [],
      spulist: []
    }
  },

  mounted(){
    this.getSkuList()
    this.getSpuList()
  },
  
  methods: {
    getSkuList: function(){
      let _skulist = []
      this.brands.map((item, index) => {
        if(item.viewtype != 2){
          item.index = index
          _skulist.push(item)
        }
      })
      this.skulist = _skulist
    },
    
    getSpuList: function(){
      let _spulist = []
      this.brands.map((item, index) => {
        if(item.viewtype == 2){
          item.index = index
          _spulist.push(item)
        }
      })
      this.spulist = _spulist
    },

    setViewType: function(subid, typeid, index){
      let that = this
      if(typeid == 1){
        let _spu = []
        that.spulist.map(item => {
          if(item.index != index){
            _spu.push(item)
          }else{
            item.viewtype = 1
            that.skulist.push(item)
          }
        })
        that.spulist = _spu
      }
      if(typeid == 2){
        let _sku = []
        that.skulist.map(item => {
          if(item.index != index){
            _sku.push(item)
          }else{
            item.viewtype = 2
            that.spulist.push(item)
          }
        })
        that.skulist = _sku
      }
      that.brands = that.skulist.concat(that.spulist)
      that.setLocalStorage( "price", that.brands )
      that.typeid = typeid
      let typedata = {
        subid: subid,
        type: typeid
      }
      let url = that.API_URL + '/v3/users/updatetype'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: typedata,
        changeOrigin: true,
        success: function(data) {
          console.log(data)
        },
        error: function(response) {
          console.log('resetpassworderror',response)
        }
      })
    },

  }

}
</script>
